const messages = {
  'en-US': {
    errorMessages: {
      invalidSecureCode: 'Invalid secure code.',
      invalidExpiryDate: 'Invalid expiration date.',
      invalidCardNumber: 'Invalid payment card number. Please try again.',
      invalidCardType: 'Your payment card is not supported. Supported card brands: Mastercard, Maestro, Visa, Amex, Discover.',
      invalidOtp: 'Invalid OTP',
      invalidEmailAddress: 'Invalid email address.',
      invalidInput: 'Invalid Input',
      invalidLocale: 'Please enter locale in valid format (ISO 639-1 alpha2 lowercase language_ISO 3166-1 alpha2 uppercase country).',
      emptyEmailAddress: 'Enter email address.',
      emptyEmailOrMobileNumber: 'Enter email address or mobile number',
      emptyCardNumber: 'Enter card number.',
      emptyExpiryDate: 'Enter expiration date.',
      emptySecureCode: 'Enter secure code.',
      profileError: 'We could not validate your profile.',
      SRCI_ID_MISSING: 'The identifier for the SRC Initiator is missing.',
      DPA_ID_MISSING: 'The identifier for the DPA is missing.',
      ACCT_INACCESSIBLE: 'The account exists but is not currently accessible (e.g. is locked).',
      AUTH_INVALID: 'Invalid federated ID token.',
      CONSUMER_ID_MISSING: 'The consumer identity was required but not supplied.',
      FRAUD: 'The user account was locked or disabled.',
      ID_FORMAT_UNSUPPORTED: 'Unsupported Id format',
      OTP_SEND_FAILED: 'The OTP could not be sent to the recipient.',
      RETRIES_EXCEEDED: 'Too many verification attempts. Please continue as a guest.',
      SESSION_ID_INVALID: 'Invalid session ID.',
      CODE_INVALID: 'The supplied OTP value was invalid. Try again.',
      CODE_EXPIRED: 'The OTP is expired. Regenerate the OTP and try again.',
      CARD_MISSING: 'The encrypted card data is missing.',
      CARD_ADD_FAILED: 'Unable to add card.',
      CARD_SECURITY_CODE_MISSING: 'Card security must be supplied.',
      CARD_INVALID: 'Invalid card number.',
      CARD_DETAIL_INVALID: 'Invalid card details.',
      ENCRYPTION_FAILED: 'Something went wrong while encrypting the card.',
      CARD_EXP_INVALID: 'Invalid card expiry date.',
      SERVICE_ERROR: 'Internal Server Error',
      INVALID_REQUEST: 'Invalid sdk request',
      AUTH_ERROR: 'Authentication Error',
      NOT_FOUND: 'Not found',
      INVALID_PARAMETER: 'Invalid code. Please try again.',
      UNKNOWN_ERROR: 'Unknown error',
      REQUEST_TIMEOUT: 'Request timeout',
      SERVER_ERROR: 'General server error',
      SRC_PROFILE_NOT_FOUND: 'SRC Profile is not found',
      AUTHENTICATION_METHODS_LOOKUP_FAILED: 'Authentication methods lookup failed',
      CONSUMER_AUTHENTICATE_FAILED: 'Authenticate failed',
      ID_LOCKED: 'We could not authenticate your profile',
      NO_CARD_FOUND: 'No cards were found for this profile',
      CHECKOUT_ERROR: {
        CARD_MISSING: 'The digital card ID or encrypted card object was required but is missing.',
        CARD_ADD_FAILED: 'Unable to add card when combined flow executed.',
        CARD_SECURITY_CODE_MISSING: 'Card security must be supplied when combined flow executed.',
        CARD_INVALID: 'Invalid card number when combined flow executed.',
        CARD_NOT_RECOGNIZED: 'The specified card was not recognized.',
        CARD_EXP_INVALID: 'Invalid card expiry date.',
        MERCHANT_DATA_INVALID: 'Merchant data is invalid.',
        UNABLE_TO_CONNECT: 'Unable to connect to / Launch DCF.',
        AUTH_INVALID: 'Invalid federated ID token.',
        TERMS_AND_CONDITIONS_NOT_ACCEPTED: 'Terms and Conditions not accepted.',
        ACCT_INACCESSIBLE: 'The account exists but is not currently accessible (e.g. is locked).',
        CHECKOUT_FAILURE: 'We could not process the checkout successfully. Please see API logs for more details.'
      },
      CONFIRMATION_ERROR: 'Confirmation API Failed, Please check API logs view for more details.',
      PAYLOAD_ERROR: 'Payload API Failed, Please check API logs view for more details.',
      SDK_LOAD: ' SDK is not loaded properly.',
      SDK_LOAD_TIMEOUT: ' SDK is not able to load in ',
      SIGN_IN_ERROR: 'Entered user name and password does not match our record. Please try again.',
      FEDERATED_TOKEN_ERROR: 'Federated Token API Failed, Please check API logs view for more details.',
      SERVICE_DOWN_ERROR: {
        STATUS_RECEIVED: ' received.',
        TRANSACTION_ID: ' Please check spunk logs with SRC transaction ID as ',
        DETAILS: ' for more details',
        PAYLOAD: 'Payload',
        CONFIRMATION: 'Confirmation'
      },
      AUTH_FAILED_ERROR: 'Continue as a guest, or try after 30 min to unlock your profile.',
      invalidNationalIdentifier: 'Invalid National Identifier.',
      CARDS_ERROR: 'Invalid card details or cards service unavailable',
      BOOTSTRAP_ERROR: 'SDK Bootstrap failed. Select atleast one SDK Network from "configuration/storefront".',
      NO_SDK_NETWORK: 'SDK Bootstrap failed. Select atleast one SDK Network.',
      SIGN_IN_ACCOUNT: 'Please Sign in into merchant account to execute this flow.',
      LOOKUP_FAILED: 'authenticationMethodsLookup failed, Please check API logs view for more details.',
      AUTHENTICATION_FAILED: 'authenticate method failed, Please check API logs view for more details.',
      NO_AUTH_METHODS: 'No Authentication method found.',
      BIND_MFA_FAILED: 'bind MFA failed, Please check API logs view for more details.',
      PKI_ASSERTION_FAILED: 'Third party PKI Assertion generation failed, Please check API logs view for more details.',
      UNBIND_MFA_FAILED: 'unbind MFA failed, Please check API logs view for more details.',
      ALREADY_BIND_MFA_MESSAGE: 'Already Bind MFA done successfully, Click on "Continue" for checkout',
      SAVE_CARD_ERROR: 'Save card API Failed.',
      invalidMinLength: 'The phone number field must be at least %d characters.',
      invalidMaxLength: 'The phone number field may not be greater than %d characters.',
      invalidPhoneNumber: 'Invalid phone number',
      CARD_ALREADY_PRESENT: 'Card is already saved.',
      AUTH_B2B_FAILED: 'Authentication API Failed, Please check API logs view for more details.',
      LOOKUP_B2B_FAILED: 'lookup API Failed, Please check API logs view for more details.',
      GET_CARDS_B2B_FAILED: 'getCards API Failed, Please check API logs view for more details.',
      GET_CARDS_TRACE_ID_MISSING: 'x-src-cx-flow-id missing in getCards API response.',
      AUTHENTICATE_FAILED: 'Authenticate Failed, Please check API logs view for more details.',
      THIRD_PARTY_FIDO_ERROR: '3rd Party FIDO Error - The operation either timed out, was canceled or was not allowed. See: https://www.w3.org/TR/webauthn-2/#sctn-privacy-considerations-client',
      RESULT_ERROR: 'Result API Failed, Please check API logs view for more details.',
      B2B_AUTH_LOOKUP_TRACE_ID_MISSING: 'x-src-cx-flow-id missing in lookup API response.',
      FIDO2_NOT_FOUND: 'FIDO2 is not available.'
    },
    successMessages: {
      BILLING_ADDRESS_SAVED: ' The Consumer Billing Address has been saved successfully.',
      SDK_LOAD: ' SDK has been loaded successfully.',
      OTP_RESEND_SUCCESS: 'OTP sent successfully.',
      FEDERATED_TOKEN_SUCCESS: 'Federated Token API call was successful, Please check API logs view for more details.',
      AUTHENTICATION_SUCCESS: 'Authentication done successfully',
      BIND_MFA_SUCCESS: 'Bind MFA done successfully, Click on "Continue" for checkout',
      UNBIND_MFA_SUCCESS: 'Unbind MFA done successfully, Click on "Continue" for checkout',
      UNBIND_SUCCESS: 'Unbind MFA done successfully',
      PAYLOAD_SUCCESS: 'Payload API call was successful',
      SAVE_CARD_SUCCESS: 'Card save successfully',
      AUTHENTICATE_SUCCESS: 'Authenticate done successfully',
      RESULT_SUCCESS: 'Result API done successfully',
      BIND_NTS_SUCCESS: 'BIND API done successfully',
      FIDO2_FOUND: 'FIDO2 is available.',
      TIMESTAMP_UPDATE: 'Timestamps for iat, exp, and authtime have been updated'
    },
    label: {
      acceptedShippingCountriesCode: 'Accepted Shipping Country Codes',
      acceptedShippingCountriesCodeDescription: 'Accepted list of shipping countries supported by the merchant. Comma-separated list of country codes. Example: US,CA,UK.',
      acceptedBillingCountriesCode: 'Accepted Billing Country codes',
      acceptedBillingCountriesCodeDescription: 'Accepted list of billing countries supported by the merchant. Comma-separated list of country codes. Example: US,CA,UK',
      chooseShippingAddressPreference: 'Choose shipping address preference',
      chooseBillingAddressPreference: 'Choose Billing Address Preference',
      dynamicCVC2Support: 'Dynamic CVC2 Support',
      cvc2Support: 'cvc2Support',
      validityPeriodMinutes: 'Validity Period Minutes',
      payloadRetrievalPreference: 'Payload Retrieval Preference',
      continue: 'CONTINUE',
      addCard: 'ADD CARD',
      cardInfo: 'Add a card to your profile',
      cancel: 'Return to Merchant',
      cancelHeader: 'Cancel',
      privacyPolicy: 'Privacy Policy',
      cookieConsent: 'Cookie Consent',
      termsConditions: 'Terms and Conditions',
      copyright: 'Copyright ©',
      copyrightText: 'SRC Shop. All Rights Reserved.',
      copyrightResText: 'Mastercard. All Rights Reserved.',
      header: 'SRC',
      selectPayloadRetrievalType: 'Select payload retrieval type',
      srciEntityId: 'SRCI entity Id',
      DpaIds: 'DPA',
      otpResend: 'Resend OTP',
      continueAnotherWay: 'Continue another way',
      otpEnterCode: 'Enter the code sent to',
      otpMobileNo: '+1(9**)***-*567',
      logOut: '(not you?)',
      srcId: 'Your email is your user ID',
      emailAndMobileUserId: 'Your email or mobile number is your user ID',
      consumerKey: 'Consumer Key',
      dpaId: 'DPA Id',
      srciId: 'SRCI Id',
      merchantOriginUrl: 'Merchant Origin URL',
      shippingMethod: 'Shipping Method',
      shippingMethodType: 'Standard',
      cardNumber: 'Credit Card Number',
      cardExpiration: 'Expiration',
      confirm: 'Confirm',
      selectConsumerProfilePreference: 'Select consumer profile details to be sent by SRCI in dpaTransactionOptions in order to get preferred consumer details in SRC Payload. The same configuration is used for passing consumer data to the DCF.',
      confirmPayment: 'Select "Confirm Payment" option to be sent by SRCI in dpaTransactionOptions',
      checkoutTypeLabel: 'Select Checkout Type',
      threeDSPreferenceLabel: 'Select 3DS Preference',
      nonPaymentSrci: 'Select Non-payment Srci',
      request: 'Request',
      response: 'Response',
      clearAll: 'Clear All',
      allLogs: 'API Logs',
      checkout: 'Checkout',
      tokenization: 'Tokenization',
      storefront: 'Storefront',
      callback: 'Callback',
      advance: 'Advanced',
      standardCheckout: 'Standard checkout',
      configurationConsole: 'Configuration Console',
      username: 'Username',
      password: 'Password',
      cartItems: 'Cart Items',
      itemPrice: 'Item Price',
      quantity: 'Quantity',
      addCartItems: 'Add Cart Item',
      currency: 'Currency',
      locale: 'Locale',
      cryptoType: 'Crypto Type',
      timeTaken: 'Log Time',
      preCheckout: 'Pre-Checkout',
      confirmation: 'Confirmation',
      shoppingCart: 'Your Shopping Cart',
      signIn: 'Sign In',
      submit: 'Submit',
      resetPwd: 'Reset Password',
      forgetPwdTxt: 'Please enter your email address to receive a reset token',
      resetTokenTxt: 'Please reset your new password',
      emailTokenMsg: 'Please use the reset token sent to your email to create a new password',
      passwordResetSuccuess: 'Password has been reset successfully',
      returnCustomer: 'Returning Customer?',
      emptyShoppingCart: 'Your Shopping Cart is Empty!',
      subtotal: 'SUBTOTAL',
      shipping: 'SHIPPING',
      tax: 'TAX',
      total: 'TOTAL',
      ON: 'ON',
      OFF: 'OFF',
      federatedID: 'Federated ID',
      jwtTestingEnable: 'Enabling testing Federated ID with test 3rd Party JWT',
      jwtPayload: 'JWT Payload',
      generate: 'Generate ID',
      cardOnFile: 'Card on File',
      secureCardOnFile: 'Secure Card on File',
      enableCOF: 'Enable COF Enrollment',
      paymentDetailsCOF: 'Retrieve Payment Details for COF',
      paymentDetailsSCOF: 'Retrieve Payment Details for SCOF',
      enrollCard: 'Enroll Card',
      digitalCardId: 'Digital Card Id',
      srciTxId: 'SRCI Tx Id',
      precheckout: 'Pre-checkout',
      encryptedPaymentData: 'Encrypted Payment Data',
      decryptedPaymentData: 'Decrypted Payment Data',
      srcInitiatorId: 'SRCInitiatorId',
      nonPatmentSrcInitiatorId: 'Non-Payment-SRCInitiatorId',
      srciDpaId: 'srciDpaId',
      srcInitiatorIdVisa: 'Visa-SRCInitiatorId',
      srciDpaIdVisa: 'Visa-srciDpaId',
      srciDpaIdDiscover: 'Discover-srcDpaId',
      srcInitiatorIdAmex: 'Amex-SRCInitiatorId',
      srciDpaIdAmex: 'Amex-srciDpaId',
      srcInitiatorIdDiscover: 'Discover-SRCInitiatorId',
      srciTransactionId: 'SRC-TransactionId',
      srcCorrelationId: 'SRC-Correlation ID',
      consumerDetails: 'Consumer Details',
      cardDetails: 'Card Details',
      paymentToken: 'Payment Token Details',
      shippingDetails: 'Shipping Details',
      billingAddressDetails: 'Billing Address Details',
      srcConsumerId: 'SRC-Consumer-ID',
      emailId: 'Email Address',
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Full Name',
      mobileNum: 'Mobile Number',
      status: 'Status',
      countryCode: 'Country Code',
      languageCode: 'Language Code',
      dateConsumerLastUsed: 'Date Consumer Last Used',
      dateConsumerAdded: 'Date Consumer Added',
      srcDigitalCardId: 'SRC-DigitalId',
      panBin: 'PAN Bin',
      panExpirationMonth: 'PAN Expiration Month',
      panExpirationYear: 'PAN Expiration Year',
      panLastFour: 'PAN Last Four',
      tokenLastFour: 'Token Last Four',
      dateOfCardCreated: 'Date Of Card Created',
      idToken: 'IDToken',
      shippingCountryCode: 'Shipping Country Code',
      shippingAddressZip: 'Shipping Address Zip',
      addressId: 'Address Id',
      city: 'City',
      line1: 'Line1',
      line2: 'Line2',
      line3: 'Line3',
      state: 'State',
      zip: 'Zip',
      cardType: 'Card Type',
      cardPaymentToken: 'Payment Token',
      tokenExpirationMonth: 'Token Expiration Month',
      tokenExpirationYear: 'Token Expiration Year',
      tokenSecurityCode: 'Token Security Code',
      paymentAccountReference: 'Payment Account Reference',
      dynamicDataExpiration: 'Dynamic Data Expiration',
      dynamicDataType: 'Dynamic Data Type',
      dynamicData: 'Dynamic Data',
      dynamicDataValue: 'Dynamic Data Value',
      srcTokenResultsData: 'SRC Token Results Data',
      key: 'Key',
      value: 'Value',
      name: 'Name',
      confirmationSuccess: 'Confirmation API call was successful, Please check API logs view for more details.',
      MASTERCARD: 'MASTERCARD',
      VISA: 'VISA',
      AMEX: 'AMEX',
      DISCOVER: 'DISCOVER',
      selectProduct: 'Select Product Quantity and Currency',
      selectLocale: 'Select Locale',
      selectCheckoutExperience: 'Select Checkout Experience',
      chooseCheckoutExperience: 'Choose the checkout experience you would like to validate.',
      mobileLookup: 'Mobile Lookup',
      supportMBL: 'Support Mobile Lookup',
      payByCard: 'Pay by Card',
      haveGiftCard: 'Have a Gift Card?',
      clickToPay: 'Click To Pay',
      emptyCart: 'Empty Cart',
      checkYourEmail: 'Check Your Email',
      verifyOtpText: 'We need to verify you',
      enterOtp: 'Enter the code ',
      sentTo: 'sent to',
      paymentMethod: 'Payment Method',
      checkoutIndicator: 'Payload Type Indicator for Checkout',
      payloadIndicator: 'Payload Type Indicator for Payload',
      checkoutType: 'Checkout Type',
      shippingPreference: 'Shipping Preference',
      billingPreference: 'Billing Preference',
      payloadIndicatorCheckout: 'Payload Indicator for checkout',
      payloadIndicatorPayload: 'Payload Indicator for Payload',
      consumerProfileDetails: 'Consumer Profile details',
      saveChanges: 'Save Changes',
      saveConfiguration: 'Save Configuration',
      showAllProducts: 'Show All Products',
      addToCart: 'Add to Cart',
      continueShopping: 'Continue Shopping',
      chooseProducts: 'Choose from our wide range of products.',
      home: 'Home',
      viewProducts: 'View All Products',
      sortBy: 'Sort by :',
      relevance: ' Relevance',
      features: 'Features',
      reviews: 'Reviews',
      qty: 'Qty:',
      enterEmail: 'Please enter email.',
      validEmail: 'Please enter valid email.',
      enterPassword: 'Please enter password.',
      validPassword: 'Password should be minimum 6 characters.',
      casePassword: 'Password is case sensitive',
      forgotPassword: 'Forget Password?',
      myAccount: 'My Account',
      signOut: ' Sign Out',
      goBack: 'Back',
      returnToMerchant: 'Return to Merchant',
      chooseCheckoutMethod: 'Choose Checkout Initialization Method',
      saveCardPurchases: 'Save my card for future purchases',
      learnMore: 'Learn More',
      addNewCard: 'Add New Card',
      gettingCards: 'We are getting the cards for you.',
      initializingSdk: 'We are initializing the checkout for you.',
      orderConfirmation: 'Your Order is Confirmed !',
      order: 'Order #',
      placeOrder: 'Place Order',
      adminSignIn: 'You are signing in as an Admin.',
      consumerSignIn: 'You are signing in as a Consumer.',
      addInfo: 'Add a card',
      signUp: 'Sign up',
      alreadyAccountLogin: 'Already have an account? Sign in',
      consumerRegistration: 'You are registering as a Consumer',
      register: 'Register',
      nationalIdentifier: 'National Identifier',
      profile: 'Profile',
      editProfile: 'Edit Your Profile',
      consumerMobileNumber: 'Mobile Number :',
      consumerEmail: 'Email :',
      consumerName: 'Name :',
      save: 'Save',
      cancelEdit: 'Cancel',
      edit: 'Edit',
      loginMsg: 'Please register or login to be able to pass consumer data to DCF.',
      billingAddressMsg: 'Please add billing address details in the Checkout tab in detailed configuration.',
      chooseNationalIdPreference: 'National Identifier Preference',
      false: 'False',
      true: 'True',
      dcfPreference: 'DCF Preference',
      chooseDcfPreference: 'Choose DCF Preference',
      complianceSettings: 'Compliance Settings',
      authSDKPanelHeader: 'SCOF Authentication Configuration',
      enableAuthSDK: 'Enable Auth SDK Flow',
      authSDKInitParam: 'Auth SDK Request Parameter',
      continueLabel: 'Continue',
      authPresentationLabel: 'AuthSDK Presentation Experience',
      selectForceChallenge: 'Select Force Challenge',
      authExecutionFlowLabel: 'TAF - AuthSDK Execution Flow',
      bindMFALable: 'BIND MFA',
      unbindMFALable: 'UNBIND MFA',
      unbindMFALable1: 'Unbind using mfaMethodInstanceId',
      unbindMFALable2: 'Unbind using externalMfaMethodInstanceId',
      unbindMFALable3: 'Unbind using resourceId',
      unbindMFALable4: 'Unbind using resourceId + mfaMethodInstanceId',
      unbindMFALable5: 'Unbind using resourceId + externalMfaMethodInstanceId',
      mfaEligibilityLable: 'Multi Factor Authentication (MFA) Eligibility',
      debitCreditCard: 'Debit/Credit Card',
      rememberMeBrowser: 'Remember me in this browser',
      auth: 'Auth Configuration',
      enableB2BAuthLookupFIDO: 'Enable B2B Auth Lookup Call',
      enableNativeIntegrationFlow: 'Enable Native Integration Flow',
      authenticationMethod: 'Select Authentication Method',
      authenticationReason: 'Select Authentication Reason',
      noSavedCard: 'You don\'t have any saved card.',
      checkoutApproach: 'Select Transaction Auth Approach',
      bindingId: 'Select Binding ID',
      certifiedMfaMethodId: 'certifiedMfaMethodId',
      saveCardForFuture: 'Save Card for future checkout',
      saveCard: 'Saved Card',
      authDpaDataLabel: 'Auth DPA Data',
      email_or_mobile: 'Please enter your Email Address or Mobile Number',
      dpaPermittedTAMethodTypes: 'DPA Permitted Transaction Authentication Method Types',
      dpaSuppressTAChallenge: 'DPA Suppress Transaction Authentication Challenge',
      LMC_INFO: 'If Payload Requested is AUTHENTICATED then, DCF will open as a popup, regardless of whether Invisible SRCI Experience is selected.',
      IDV_INFO_1: 'You have selected ',
      IDV_INFO_2: ' as IDV approach. Select appropriate request parameters to proceed further. If you want to change IDV approach ',
      IDV_INFO_3: 'Click here',
      authenticationPreferenceLabel: 'Include authenticationPreference object in dpaTransactionOptions',
      payloadRequestedLabel: 'Payload Requested',
      authMethodTypeLabel: 'Authentication Method Types',
      suppressChallengeLabel: 'Suppress Challenge',
      acquirerDataLabel: 'Include acquirerId and acquirerBin in dpaData in init() request',
      scofFlowOptions: 'Select IDV Approach',
      enableThirdPartyFIDOLabel: 'Enable 3rd party FIDO',
      enableThirdPartyPKILabel: 'Enable 3rd party PKI',
      selectPkiFormat: 'Select PKI Format',
      otpInputLabel: 'Your bank needs to verify you',
      authenticationFactorLabel: 'Authentication Factor',
      ntsIntegrationFlowInfo: 'Native Integration flow supports MDES B2B API flow only',
      savedCardMessage: 'You have added a new card',
      enableMPT: 'Enable Manual PAN tokenization',
      saveMyInfo: 'Save my information with',
      fastCheckout: 'for fast, secure checkout',
      selectAuthReasonForB2BLookup: 'Select Authentication reason for B2B Auth lookup',
      enableB2BAuthenticate: 'Enable Authenticate Call',
      enableTokenizationConsent: 'Enable Tokenization Consent',
      complianceSettingsAndAssuranceData: 'Compliance Settings & Assurance Data',
      enableENCFlow: 'Enable ENC Flow',
      issuer: 'Issuer',
      refresh: 'Refresh',
      enableConsumerAuthenticationModule: 'Enable Consumer Authentication Module',
      consumerAuthModuleLabel1: 'Select Execution flow',
      consumerAuthModuleLabel2: 'Select windowRef type'
    },
    sdk: {
      mastercard: 'Mastercard',
      visa: 'Visa',
      amex: 'Amex',
      discover: 'Discover'
    },
    header: {
      checkoutExperience: 'Checkout Experience',
      locale: 'Locale',
      shippingAddressPreference: 'Shipping Address Preference',
      billingAddressPreference: 'Billing Address Preference',
      payloadRetrievalPreference: 'Payload Retrieval Preference',
      dynamicTokenVerification: 'Dynamic Token Verification Code (UCAF bypass)',
      selectEnvironment: 'Select Environment',
      MastercardCryptoOption: 'Mastercard Network Cryptogram Option',
      DSRP: 'DSRP',
      srciCredentials: 'SRCI Credentials',
      paymentMethod: 'Choose a card',
      loader: 'SRC is in progress, Kindly go to SRC screen. Do not refresh or close this window.',
      consumerProfilePreference: 'Consumer Preference in Payload & DCF Screen',
      checkoutType: 'Checkout Type',
      threeDSPreferenceHeading: '3DS Preference',
      reviewOrder: 'Please Review Your Order',
      cartItems: 'Cart Items',
      billingInformation: 'Billing and Contact Information',
      paymentInformation: 'Payment',
      shippingInformation: 'Shipping Address',
      add: 'Add',
      jwtTest: 'Federated ID Testing',
      jwtSettings: 'JWT Settings',
      cart: 'Review Cart and Place Order',
      orderSummary: 'Order Summary',
      loginOrRegister: 'Login to Account',
      selectClickToPay: 'You have selected to pay with Click To Pay',
      selectPaymentMethod: 'Choose Payment Method',
      closeIcon: 'X',
      login: 'Login',
      quickConfiguration: 'Quick Configuration',
      contactInfo: 'Contact Information',
      liabilityShiftTFAHeading: 'C2P Authentication Configuration',
      tokenAuthenticationConfigHeading: 'Token Authentication Framework Configuration',
      MDESIDVConfigLabel: 'MDES IDV Configuration',
      MPTHeading: 'Manual PAN tokenization',
      consumerAuthenticationModule: 'Consumer Authentication Module',
      tokenizationConsent: 'Tokenization Consent'
    },
    description: {
      dynamicCVC2Support: 'Flag to determine whether the merchant supports dcvc2',
      logoutInfoNote: 'Information is from your SRC profile',
      note: 'PLEASE NOTE:',
      footerDescription: 'This is a test storefront to demo SRC checkout. Your credit cards will not be charged and products\n' +
        '        will not be shipped.',
      preCheckout: 'Click pre-checkout button to initiate checkout after selecting required configurations.',
      srcCheckout: 'Transaction settings has changed. Click Pre-Checkout button to re-initiate the transaction.',
      confirmation: 'Click confirmation button to initiate confirmation call to src',
      cryptoGramOptions: 'Supported Cryptogram type for each networks are as below :',
      profileOption: 'Your email or mobile number will be used to verify you. Message/data rates may apply.'
    },
    footer: {
      knowMore: 'Know more about Click To Pay',
      contactUs: 'Contact Us',
      requestInfo: 'Request Information',
      askMastercard: 'Ask Mastercard'
    },
    cardEnrollment: {
      checkoutFaster: 'Check out faster with',
      clickToPay: 'Click to Pay',
      acceptedNetworks: 'We accept',
      footerText: 'This is test SRCI and you will not be charged for this transaction.',
      getStarted: 'GET STARTED',
      alert_content: 'Thanks for using START. This is a test SRCI.',
      signInUser: ' SIGN IN AS RETURNING USER',
      checkoutAsUser: 'CHECKOUT AS NEW USER'
    },
    addressForm: {
      billingAddressTitle: 'Billing address',
      cityTown: 'City',
      countryCode: 'Country',
      line1: 'Street address',
      line2: 'Apartment or suite',
      line3: 'Address line 3',
      optional: '(optional)',
      phoneNumber: 'Mobile number',
      postalCode: 'Zip code',
      shippingAddressTitle: 'Shipping address',
      streetName: 'Street name',
      streetNumber: 'Street number',
      subdivision: 'State',
      complemento: 'Complemento',
      neighborhood: 'Neighborhood',
      name: 'Billing Address Name'
    },
    configTabLabels: {
      checkout: 'This section contains SRCI onboarding credentials, consumer data & merchant billing and shipping preferences.',
      callback: 'This is printed after a transaction is complete and decrypted payload is available. Testers can check the expected values vis-a-vis actual values in API log view.',
      storefront: 'This section contains sections impacting the functionality of the merchant application.',
      tokenization: 'This section provides details of supported cryptogram type for every network.',
      advance: 'This section can be used to test card on file, aggregator checkout and select checkout experience.',
      federatedId: 'This section can be used to perform testing Federated ID with test 3rd Party JWT.',
      auth: 'This section contains Auth configuration to test SCOF use cases (TAF, FIDO) and C2P Liability Shift use cases (LMC, LFV, FED, LWT).'
    },
    clickToPayModal: {
      welcomeTo: 'Welcome to',
      clickToPay: 'Click to Pay',
      clickToPayMessage: 'A fast, secure payment method supported by Mastercard, Visa, American Express and Discover',
      line1: 'Keep your information safe and secure',
      line2: 'Use it at merchants worldwide',
      line3: 'Set up once for hassle-free payments in the future',
      okLabel: 'Ok'
    }
  }
}

export default messages
